import Table from './Table.vue'

export default Table
